import React, { useEffect, useState, forwardRef } from "react";
import { Header } from "../../components/Header/Header";
import { Navigator } from "../../components/Navigator/Navigator";
import photo from "../../assets/Profile/Profile-IMG.png";
import { CustomInput } from "../../components/CustomInput";
import { api } from "../../context/Auth";
import img from "../../assets/Profile/img.png";
import addIcon from "../../assets/Home/icon-plus.svg";
import alertIcon from "../../assets/Home/alert-icon.svg";
import closeIcon from "../../assets/Profile/XIcon.svg";
import { Modal } from "../../components/Modal";
import { AddCSV } from "../../components/AddCSV";
import { useAuth } from "../../context/AuthContext";
import { enterpriseProfile } from "../../context/Auth";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { ProfileLoader } from "../../components/SkeletonLoaders/ProfileLoader";
import { EnterpriseInfo } from "./EnterpriseInfo";
// import { NemuProfile } from "./NemuProfile";

const TextInputWithLimit = forwardRef(
  ({ characterLimit, textInput, ...props }, ref) => {
    return (
      <div style={{ width: "100%" }} className="">
        <textarea
          ref={ref} // Pasa el ref a la etiqueta textarea
          style={{
            border: "1px solid #B5B5B5",
            resize: "none",
            width: "100%",
            padding: "12px",
            borderRadius: "4px",
            placeholder: "#b5b5b5",
          }}
          rows="5"
          cols="50"
          maxLength={characterLimit} // Límite de caracteres
          placeholder={textInput}
          {...props} // Pasa otras propiedades como `onChange` o `value`
        />
      </div>
    );
  }
);

function ReadOnlyField({ label, value }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-[11px] font-medium text-gray-400 uppercase tracking-wider">{label}</span>
      <span className="text-[14px] text-gray-800">{value || <span className="text-gray-300 italic">Sin información</span>}</span>
    </div>
  );
}

function Profile() {
  const {
    enterprise,
    loading,
    user,
    acknowledge,
    setAcknowledge,
    getProfileAcknowledge,
    count,
  } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();
  const viewUserId = location.state?.viewUserId ?? null;
  const [viewData, setViewData] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);

  useEffect(() => {
    if (viewUserId) {
      setViewLoading(true);
      enterpriseProfile(viewUserId)
        .then(res => setViewData(res.data))
        .catch(err => console.error(err))
        .finally(() => setViewLoading(false));
    }
  }, [viewUserId]);

  const [preview, setPreview] = useState(photo);
  const [coverPage, setCoverPage] = useState(null);
  const api = process.env.REACT_APP_API_URL;

  const fetchProfileAcknowledge = async (id) => {
    try {
      const response = await getProfileAcknowledge(id);
      // console.log(response);
      setAcknowledge(response);
      
    } catch (error) {
      console.error("Error al obtener el perfil de la empresa:", error);
    }
  };


  useEffect(() => {
    if (enterprise) {
      setPreview(enterprise.profile_picture ? api + "/" + enterprise.profile_picture : photo);
      setCoverPage(enterprise.profile?.cover_page ? api + "/" + enterprise.profile.cover_page : photo);
      fetchProfileAcknowledge(user.id);
    }
  }, [enterprise]);


  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    if (file) {
      // Mostrar preview
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);

      // Preparar y enviar la imagen
      try {
        const formData = new FormData();
        formData.append("image", file);

        const response = await axios.patch(
          `${api}/user/update-picture/${user.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "¡Imagen actualizada!",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (error) {
        console.error("Error al actualizar la imagen:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo actualizar la imagen",
          showConfirmButton: true,
        });
      }
    }
  };

  if (viewUserId) {
    const ent = viewData?.enterprise ?? {};
    const profilePic = viewData?.profile_picture ? api + "/" + viewData.profile_picture : photo;
    return (
      <main className="w-[100vw] max-w-[100vw] bg-[#eaeaea]">
        <Header />
        <div className="flex w-full pr-[20px] pb-[20px]">
          <Navigator />
          {viewLoading ? (
            <ProfileLoader />
          ) : viewData ? (
            <div className="grid grid-cols-[1fr_3fr] h-[calc(100svh-120px)] w-full gap-[10px]">
              {/* Left panel */}
              <div className="flex flex-col gap-[2px] max-h-[calc(100vh-120px)] overflow-y-auto">
                <div className="w-full bg-white p-[8px] h-min rounded-[4px]">
                  <div className="flex flex-col gap-[10px]">
                    <img className="w-full rounded" src={profilePic} alt="empresa" />
                    <div className="flex flex-col gap-[4px]">
                      <h1 className="text-[24px]">{ent.name || "Sin nombre"}</h1>
                      <span className="text-[12px]">{ent.address || ""}</span>
                      {ent.giro && <span className="text-[12px] text-nemu-azul font-medium">{ent.giro}</span>}
                    </div>
                  </div>
                </div>
                <div className="flex w-full bg-white justify-between px-[16px] py-[12px] h-min rounded-[4px]">
                  <h1 className="text-[20px]">Miembro desde</h1>
                  <span className="text-[14px] text-gray-500">{new Date(viewData.createdAt).toLocaleDateString()}</span>
                </div>
                <button
                  onClick={() => navigate(-1)}
                  className="flex items-center justify-center gap-2 w-full bg-white hover:bg-nemu-platino text-nemu-black text-[14px] font-medium px-4 py-3 rounded-[4px] transition-colors"
                >
                  ← Volver
                </button>
              </div>

              {/* Right panel - editable by admin */}
              <div className="flex flex-col w-full h-min py-8 px-6 bg-white rounded-[4px] gap-[20px] max-h-[calc(100vh-120px)] overflow-y-auto">
                <hr className="border-t-1 border-nemu-plata" />
                <EnterpriseInfo enterpriseData={viewData.enterprise} targetUserId={viewUserId} />
              </div>
            </div>
          ) : (
            <div className="flex-1 flex items-center justify-center text-gray-400">No se encontró información de la empresa.</div>
          )}
        </div>
      </main>
    );
  }

  return (
    <main className="w-[100vw] max-w-[100vw] bg-[#eaeaea]">
      <Header />
      <div className="flex w-full pr-[20px] pb-[20px] ">
        <Navigator />
        {loading ? (
          //LOADER
          <ProfileLoader/>
          //LOADER
        ) : (
          <div className="grid grid-cols-[1fr_3fr] h-[calc(100svh-120px)] w-full gap-[10px]">
            <div className="flex flex-col gap-[2px] max-h-[calc(100vh-120px)] overflow-y-auto">
              <div className="w-full bg-white p-[8px] h-min rounded-[4px]">
                <div className="flex flex-col gap-[10px] ">
                  {enterprise.profile.profile_picture ? (
                    <div className="relative group">
                      <img
                        className="w-full"
                        src={coverPage}
                        alt="photo_profile"
                      />
                      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity">
                        <label className="cursor-pointer p-2 rounded-full bg-white hover:bg-gray-100">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                          <input
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={(e) => console.log("Hola")}
                          />
                        </label>
                      </div>
                    </div>
                  ) : (
                    <div className="relative group">
                      <img
                        className="w-full hover:opacity-80 transition-opacity"
                        src={preview || photo}
                        alt="photo_profile"
                      />

                      {/* Overlay con ícono de cámara al hover */}
                      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity">
                        <label className="cursor-pointer p-2 rounded-full bg-white hover:bg-gray-100">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                          <input
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={handleImageChange}
                          />
                        </label>
                      </div>
                    </div>
                  )}
                  <div className="flex flex-col gap-[4px]">
                    <h1 className="text-[24px]" onClick={() => console.log(acknowledge)}>
                      {enterprise.enterprise.name}
                    </h1>
                    <span className="text-[12px]">
                      {enterprise.enterprise.address}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex w-full bg-white justify-between px-[16px] py-[12px] h-min rounded-[4px] ">
                <h1 className="text-[20px] ">Número de proyectos</h1>
                <h1 className="text-[20px]">{count}</h1>
              </div>
              <div className="flex flex-col w-full bg-white justify-between px-[16px] py-[12px] h-min rounded-[4px] ">
                <span className="text-[12px]">Miembro de Nemu desde</span>
                {new Date(enterprise.createdAt).toLocaleDateString()}
              </div>
            </div>
            
            <div className="flex flex-col w-full h-min py-8 px-6 bg-white rounded-[4px] gap-[20px] max-h-[calc(100vh-120px)] overflow-y-auto">
              <hr className="border-t-1 border-nemu-plata" />
              {true && (
                <EnterpriseInfo />
              )}
            </div>
          </div>
        )}
      </div>
    </main>
  );
}

export { Profile };
